import React from 'react'
import { FlexContainer, Paragraph, PureSpinner, Button } from 'heliocor-ui'
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components'

const CameraLoader = ({height}) => 
    <FlexContainer 
        height={`${height}px`} 
        alignItems='center' 
        justifyContent='center'
        >
        <PureSpinner color='grey500'/>
    </FlexContainer>

const CameraIsNotActive = ({refreshCameraSettings}) => {
    const { t } = useTranslation()

    return (
        <FlexContainer justifyContent='center' alignItems='center'>
            <FlexContainer justifyContent='center' alignItems='center' column textAlign='center' width='300px'>
                <Paragraph value={t('warning.activateCamera')} />
                <Button 
                    fixDimension={{width: '100px'}}
                    value={t("button.refresh")}
                    onClick={() => refreshCameraSettings()} />
            </FlexContainer>
        </FlexContainer>
    )
}

const ActionsWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
`

const OuterBox = styled.div(({ 
    height 
}) => css`
    display:block;
    height: 100%;
    position:relative;
    margin: 25px;
    img {
        max-height: ${height}px;;
    }
`)

export {
    OuterBox,
    ActionsWrapper,
    CameraLoader,
    CameraIsNotActive,
}